export const ADD_SPEECH_NOTES_FORM_INPUTS = () => {
  return [
    {
      sectionHeading: 'Details',
      rowNumber: 3,
    },

    {
      label: 'Client',
      name: 'clientId',
      type: 'searchableSelect',
      options: [],
      disabled: false,
      required: true,
      rowNumber: 4,
    },
    {
      label: 'Plan Date',
      name: 'date',
      type: 'date',
      required: true,
      rowNumber: 4,
    },
    // {
    //   sectionHeading: 'Diagnosis',
    //   rowNumber: 3,
    // },
    {
      label:'Diagnosis',
      name: 'diagnosis',
      type: 'textarea',
      required: true,
      rowNumber: 5,
      minRows: 3,
    },
    // {
    //   sectionHeading: 'Pre-treatment Status',
    //   rowNumber: 5,
    // },
    {
      label:'Pre-treatment Status',
      name: 'preTreatmentStatus',
      type: 'text',
      required: true,
      rowNumber: 6,
    },
    // {
    //   sectionHeading: 'Medical History',
    //   rowNumber: 7,
    // },
    {
      label:'Medical History',
      name: 'medicalHistory',
      type: 'textarea',
      required: true,
      rowNumber: 8,
      minRows: 4,
    },
    // {
    //   sectionHeading: 'Previous treatment Recieved',
    //   rowNumber: 9,
    // },
    {
      label:'Previous Treatment',
      name: 'previousTreatment',
      type: 'textarea',
      required: true,
      rowNumber: 10,
      minRows: 4,
    },
    // {
    //   sectionHeading: 'Complicating Issues',
    //   rowNumber: 11,
    // },
    {
      label:'Complicating Issues',
      name: 'complicatingIssues',
      type: 'textarea',
      required: true,
      rowNumber: 12,
      minRows: 4,
    },
    // {
    //   sectionHeading: 'Other',
    //   rowNumber: 13,
    // },
    {
      label:'Other',
      name: 'other',
      type: 'textarea',
      required: true,
      rowNumber: 14,
      minRows: 3,
    },

    // {
    //   sectionHeading: 'Prognosis',
    //   rowNumber: 17,
    // },

    {
      label:'Prognosis',
      name: 'prognosis',
      type: 'textarea',
      required: true,
      rowNumber: 18,
      minRows: 3,
    },

    // {
    //   sectionHeading: 'Complicating factors or other considerations',
    //   rowNumber: 19,
    // },

    {
      label:'Complicating factors or other considerations',
      name: 'complicatingFactors',
      type: 'textarea',
      required: true,
      rowNumber: 20,
      minRows: 3,
    },
    // {
    //   sectionHeading: 'Amendments to treatment plan',
    //   rowNumber: 21,
    // },

    {
    label: 'Amendments to treatment plan',
      name: 'amendments',
      type: 'textarea',
      required: true,
      rowNumber: 22,
      minRows: 3,
    },

    // {
    //   sectionHeading: 'Date of Amendment',
    //   rowNumber: 49,
    // },
    {
      label: 'Date of Amendment',
      name: 'dateOfAmendment',
      type: 'date',
      required: true,
      rowNumber: 50,
    },

    {
      sectionHeading: 'Long Term Goal',
      rowNumber: 25,
    },
    {
      type: 'SpeechTherapyDialog',
      rowNumber: 26,
    },
  ]
}

export const ADD_SPEECH_NOTE_ENTRY_FORM_INPUTS = () => {
  return [
    {
      label: 'Client',
      name: 'clientId',
      type: 'searchableSelect',
      options: [],
      disabled: true,
      required: true,
      rowNumber: 3,
    },
    {
      label: 'Progress Report Date',
      name: 'progressReportDate',
      type: 'date',
      required: true,
      rowNumber: 4,
    },
    {
      label: 'Treatment Plan Date',
      name: 'treatmentPlanStartDate',
      type: 'date',
      required: true,
      disabled:true,
      rowNumber: 4,
    },
    {
      label: 'No. of sessions completed',
      name: 'sessionsCompleted',
      type: 'text',
      required: true,
      disabled:true,
      rowNumber: 4,
    },
    {
      sectionHeading: 'Next Steps',
      rowNumber: 49,
    },
    {
      name: 'availability',
      type: 'radio',
      rowNumber: 50,
      required: true,
      options: [
        {
          label: 'Continue with treatment',
          value: 'continuePlan',
        },
        {
          label: 'Amend Treatment plan',
          value: 'amendTreatmentPlan',
        },
         {
          label: 'Dismiss Patient as treatment goals have been achieved',
          value: 'dismissPatient',
        },
      ],
    },
    {
      sectionHeading: 'Long Term Goal',
      rowNumber: 25,
    },
    {
      sectionHeading: 'Next Session',
      rowNumber: 60,
    },
    {
        label: 'Next Session',
        name: 'nextSession',
        type: 'date',
        required: true,
        rowNumber: 61,
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        minDate: new Date(new Date().setDate(new Date().getDate() + 1))
    },
  ]
}

export const EDIT_SPEECH_NOTES_FORM_INPUTS = () => {
 return [
    {
      sectionHeading: 'Details',
      rowNumber: 3,
    },

    {
      label: 'Client',
      name: 'clientId',
      type: 'searchableSelect',
      options: [],
      disabled: true,
      required: true,
      rowNumber: 4,
    },
    {
      label: 'Plan Date',
      name: 'date',
      type: 'date',
      required: true,
      disabled: true,
      rowNumber: 4,
    },
    // {
    //   sectionHeading: 'Diagnosis',
    //   rowNumber: 3,
    // },
    {
      label:'Diagnosis',
      name: 'diagnosis',
      type: 'textarea',
      required: true,
      rowNumber: 5,
      minRows: 3,
    },
    // {
    //   sectionHeading: 'Pre-treatment Status',
    //   rowNumber: 5,
    // },
    {
      label:'Pre-treatment Status',
      name: 'preTreatmentStatus',
      type: 'text',
      required: true,
      rowNumber: 6,
    },
    // {
    //   sectionHeading: 'Medical History',
    //   rowNumber: 7,
    // },
    {
      label:'Medical History',
      name: 'medicalHistory',
      type: 'textarea',
      required: true,
      rowNumber: 8,
      minRows: 4,
    },
    // {
    //   sectionHeading: 'Previous treatment Recieved',
    //   rowNumber: 9,
    // },
    {
      label:'Previous Treatment',
      name: 'previousTreatment',
      type: 'textarea',
      required: true,
      rowNumber: 10,
      minRows: 4,
    },
    // {
    //   sectionHeading: 'Complicating Issues',
    //   rowNumber: 11,
    // },
    {
      label:'Complicating Issues',
      name: 'complicatingIssues',
      type: 'textarea',
      required: true,
      rowNumber: 12,
      minRows: 4,
    },
    // {
    //   sectionHeading: 'Other',
    //   rowNumber: 13,
    // },
    {
      label:'Other',
      name: 'other',
      type: 'textarea',
      required: true,
      rowNumber: 14,
      minRows: 3,
    },

    // {
    //   sectionHeading: 'Prognosis',
    //   rowNumber: 17,
    // },

    {
      label:'Prognosis',
      name: 'prognosis',
      type: 'textarea',
      required: true,
      rowNumber: 18,
      minRows: 3,
    },

    // {
    //   sectionHeading: 'Complicating factors or other considerations',
    //   rowNumber: 19,
    // },

    {
      label:'Complicating factors or other considerations',
      name: 'complicatingFactors',
      type: 'textarea',
      required: true,
      rowNumber: 20,
      minRows: 3,
    },
    // {
    //   sectionHeading: 'Amendments to treatment plan',
    //   rowNumber: 21,
    // },

    {
      label: 'Amendments to treatment plan',
      name: 'amendments',
      type: 'textarea',
      required: true,
      rowNumber: 22,
      minRows: 3,
    },

    // {
    //   sectionHeading: 'Date of Amendment',
    //   rowNumber: 49,
    // },
    {
      label: 'Date of Amendment',
      name: 'dateOfAmendment',
      type: 'date',
      required: true,
      rowNumber: 50,
    },

    {
      sectionHeading: 'Long Term Goal',
      rowNumber: 25,
    },
    {
      type: 'SpeechTherapyDialog',
      rowNumber: 26,
      isDisabled: false,
    },
  ]
}

export const EDIT_NOTE_ENTRY_FORM_INPUTS = () => {
  return [
    {
      label: 'Client',
      name: 'clientId',
      type: 'searchableSelect',
      options: [],
      disabled: true,
      required: true,
      rowNumber: 2,
    },
    {
      label: 'Progress Report Date',
      name: 'progressReportDate',
      type: 'date',
      // required: true,
      rowNumber: 3,
    },
    {
      label: 'Treatment Plan Date',
      name: 'treatmentPlanStartDate',
      type: 'date',
      required: true,
      disabled:true,
      rowNumber: 3,
    },
    {
      label: 'No. of sessions completed',
      name: 'sessionsCompleted',
      type: 'text',
      required: true,
      disabled:true,
      rowNumber: 3,
    },
    {
      sectionHeading: 'Next Steps',
      rowNumber: 49,
    },
        {
      name: 'availability',
      type: 'radio',
      rowNumber: 50,
      // required: true,
      options: [
        {
          label: 'Continue with treatment',
          value: 'continuePlan',
        },
        {
          label: 'Amend Treatment plan',
          value: 'amendTreatmentPlan',
        },
         {
          label: 'Dismiss Patient as treatment goals have been achieved',
          value: 'dismissPatient',
        },
      ],
    },
    {
      sectionHeading: 'Long Term Goal',
      rowNumber: 25,
    },
     {
      sectionHeading: 'Next Session',
      rowNumber: 60,
    },
    {
        label: 'Next Session',
        name: 'nextSession',
        type: 'date',
        // required: true,
        rowNumber: 61,
        maxDate: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
        minDate: new Date(new Date().setDate(new Date().getDate() + 1))
    },
  ]
}
